import { c as _c } from "react/compiler-runtime";
import { useIsFetching } from '@tanstack/react-query';
import { useRouterState } from '@tanstack/react-router';
import { useEffect, useState } from 'react';

// Query ids that should NOT trigger the global loading state
// Matches both fetch-hosted _id keys and legacy plain string query keys
const EXCLUDED_QUERY_IDS = ['validate',
// Legacy session validity polling (idv)
'getHostedCheckSession',
// Session validity check (fetch-hosted)
'hostedOnboardingD2pStatus',
// D2P status polling
'hostedOnboardingD2pGenerate',
// D2P token generation
'hostedOnboardingD2pSms',
// D2P SMS sending
'hostedOnboardingD2pStatusPost',
// D2P status updates
'get-d2p-status' // Legacy D2P status polling (idv useGetD2PStatus)
];
export const useIsLoading = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      type: "all",
      predicate: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isFetching = useIsFetching(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      select: _temp3
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isRouterPending = useRouterState(t1);
  const rawPending = isRouterPending || isFetching > 0;
  const [isLoading, setIsLoading] = useState(rawPending);
  let t2;
  let t3;
  if ($[2] !== rawPending) {
    t2 = () => {
      if (rawPending) {
        setIsLoading(true);
      } else {
        const timeout = setTimeout(() => setIsLoading(false), 100);
        return () => clearTimeout(timeout);
      }
    };
    t3 = [rawPending];
    $[2] = rawPending;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  return isLoading;
};
function _temp(query) {
  const firstKey = query.queryKey[0];
  if (typeof firstKey === "string") {
    return !EXCLUDED_QUERY_IDS.includes(firstKey);
  }
  const queryId = (firstKey as {
    _id?: string;
  } | undefined)?._id ?? "";
  return !EXCLUDED_QUERY_IDS.includes(queryId);
}
function _temp2(m) {
  return m.status === "error";
}
function _temp3(s) {
  return (s.status === "pending" || s.isLoading || s.isTransitioning) && !s.matches.some(_temp2);
}